import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Component, Inject, OnInit} from '@angular/core';
import {ClipboardService} from 'ngx-clipboard';
import {SnackBarService} from '../services/snackbar.service';
import {Utils} from '../utils/utils';
import {BridgeAdUnit} from '../domain/bridge-ad-unit.model';
import {DevicePlacement} from '../domain/device-placement.model';
import {BidderConfig} from '../domain/bidder-config.model';
import {MatTabChangeEvent} from '@angular/material';

@Component({
  selector: 'cm-vast-integration-dialog',
  template: `
    <h3 class="mat-dialog-title">
      VAST Integration
    </h3>
    <mat-dialog-content>
      <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" [selectedIndex]="0">
        <mat-tab label="Podcast">
          <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" (selectedTabChange)="onSelectionChange($event)" [selectedIndex]="0">
            <mat-tab label="Generic">
              <div>
                                <textarea #genericTag
                                          title="Pixel tag"
                                          class="mat-input-element textarea-note w-100 mb-1"
                                          [(ngModel)]="genericTemplate"
                                          readonly></textarea>

              </div>

            </mat-tab>
            <mat-tab label="Megaphone">
                <textarea #megaphoneTag
                          title="Pixel tag"
                          class="mat-input-element textarea-note w-100 mb-1"
                          [(ngModel)]="genericTemplate"
                          readonly></textarea>
            </mat-tab>
          </mat-tab-group>
        </mat-tab>
        <textarea #foo
                  title="Pixel tag"
                  class="mat-input-element textarea-note w-100 mb-1"
                  [(ngModel)]="genericTemplate"
                  readonly></textarea>

      </mat-tab-group>
    </mat-dialog-content>
    <mat-dialog-actions class="justify-content-center">
      <button mat-raised-button color="primary" [ngxClipboard]="this.currentLabel === 'Generic' ? genericTag : megaphoneTag" (cbOnSuccess)="onCopyToClipboard()" class="iconed  mb-3 mb-sm-0">
        <i class="fas fa-clipboard"></i>
        <span>Copy to clipboard</span>
      </button>
      <button mat-raised-button color="primary" (click)="openDocs()" class="iconed  mb-3 mb-sm-0">
        <i class="fas fa-external-link"></i>
        <span>API Docs</span>
      </button>
      <button mat-raised-button color="" class="mr-1" [mat-dialog-close]="false">Close</button>
    </mat-dialog-actions>
  `,
  styles: [`
    .mat-input-element.textarea-note {
      min-height: 220px;
      overflow: auto;
    }

    ::ng-deep .mat-form-field-appearance-legacy .mat-form-field-underline {
      display: none;
    }
  `]
})
export class VastIntegrationDialogComponent implements OnInit {

  genericTemplate = '';
  megaphoneTemplate = '';
  currentLabel = 'Generic';

  constructor(public dialogRef: MatDialogRef<VastIntegrationDialogComponent>,
              public snackBarService: SnackBarService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit() {
    this.genericTemplate =   `https://e.serverbid.com/mpb/get?s=${this.data.placementHash}&rt=vast&u=%%ua%%&i=%%ip%%&kw=%%itunes_categories%%&cb=%%cachebuster%%cat=IAB_CATEGORIES&appstoreurl=APP_STORE_URL&appname=APP_NAME&appbundle=APP_BUNDLE_ID&ifa=GENERIC_DEVICEID&v_delivery=3&c_audio_feed_type=3&c_url=%%mediaurl%%&c_id=CONTENT_ID&c_title=CONTENT_TITLE&c_series=CONTENT_SERIES&c_genre=CONTENT_GENRE&c_lang=CONTENT_LANGUAGE&c_dur=CONTENT_DURATION&secure=1`;
    this.megaphoneTemplate = `https://e.serverbid.com/mpb/get?s=${this.data.placementHash}&rt=vast&u=%%ua%%&i=%%ip%%&kw=%%itunes_categories%%&cb=%%cachebuster%%&appstoreurl=&appname=&appbundle=&ifa=%%sessionid%%&v_delivery=3&c_audio_feed_type=3&c_url=%%rssurl%%&c_id=%%mediaurl%%&c_title=%%episodeid%%&c_series=%%podcastid%%&secure=1`;
  }

  onCopyToClipboard() {
    this.snackBarService.success('Copied to clipboard!');
  }

  openDocs() {
    if (this.currentLabel === 'Generic') {
      window.open('https://consumable.atlassian.net/wiki/spaces/CD/pages/89358394/Consumable+Ad+API', '_blank');

    } else {
      window.open('https://support.megaphone.fm/en/articles/5104065-using-vast-tag-urls-with-orders', '_blank');
    }
  }

  onSelectionChange($event: MatTabChangeEvent) {
    this.currentLabel = $event.tab.textLabel;
  }
}

